import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader2, AlertTriangle } from 'lucide-react';
import { ssoStartUrl } from '../../utils/environment';
import { createPkcePair, saveVerifier } from '../../utils/ssoPkce';
import flexbeeLogo from '../../assets/media/flexbee-no-bg.webp';
import { PageWrapper, FormCard, LogoContainer, FormTitle, ErrorMessage, GradientLinkButton } from '../login/styles';

// Entra "Uygulamalarım" / ADFS portal kutucuğu (Sign-on URL) buraya düşer (spec §5.4): verifier üretilir ve akış
// challenge ile yeniden başlatılır — kutucuk girişi de bilet/verifier korumasından geçer.
export default function SsoStartPage() {
  const { t } = useTranslation();
  const [failed, setFailed] = useState(false);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const connection = new URLSearchParams(window.location.search).get('connection');
    if (!connection) { setFailed(true); return; }
    createPkcePair()
      .then(({ verifier, challenge }) => {
        saveVerifier(verifier);
        window.location.replace(ssoStartUrl({ connection, challenge }));
      })
      .catch(() => setFailed(true));
  }, []);

  return (
    <PageWrapper>
      <FormCard>
        <LogoContainer><img src={flexbeeLogo} alt="Flexbee" /></LogoContainer>
        {failed ? (
          <>
            <ErrorMessage role="alert"><AlertTriangle size={16} /><span>{t('responseErrors.auth.sso.notConfigured')}</span></ErrorMessage>
            <GradientLinkButton as="a" href="/login">{t('login.sso.backToLogin')}</GradientLinkButton>
          </>
        ) : (
          <div role="status" aria-live="polite"><Loader2 size={20} /><FormTitle>{t('login.sso.redirecting')}</FormTitle></div>
        )}
      </FormCard>
    </PageWrapper>
  );
}
